var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('h1',{staticClass:"text-lg-h3 text-sm-h4 text-h5 font-weight-bold mb-3 text-center"},[_vm._v(" "+_vm._s(_vm.name.toUpperCase())+" ")]),_c('v-responsive',{staticClass:"mx-auto mb-4",attrs:{"width":"56"}},[_c('v-divider',{staticClass:"primary",staticStyle:{"border":"3px solid"}}),_c('v-divider')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }